import { render, staticRenderFns } from "./ReturnItems.vue?vue&type=template&id=193a5795&scoped=true"
import script from "./ReturnItems.vue?vue&type=script&lang=js"
export * from "./ReturnItems.vue?vue&type=script&lang=js"
import style0 from "./ReturnItems.vue?vue&type=style&index=0&id=193a5795&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "193a5795",
  null
  
)

export default component.exports